export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13105.a2a12a1d.jpg";